import dayjs from "dayjs";
import { Util } from "../";

const util = Util.getInstance();

export function fenToYuan(value) {
  return util.getFormattedPrice(Number(value || 0));
}

export function formatMoneyFen(value) {
  return `¥${fenToYuan(value)}`;
}

export function defaultDateRange(days = 7) {
  const end = dayjs().startOf("day");
  const start = end.subtract(days - 1, "day");
  return [start, end];
}

export function formatDateRange(range) {
  if (!range || range.length !== 2) {
    return {};
  }
  return {
    start_date: range[0].format("YYYY-MM-DD"),
    end_date: range[1].format("YYYY-MM-DD"),
  };
}

export function buildOrderListUrl(startDate, endDate) {
  return `/main/order/list?timeRange=${startDate}~${endDate}`;
}

export function buildCommissionListUrl(startDate, endDate) {
  if (startDate && endDate) {
    return `/main/proxy/commission-list?timeRange=${startDate}~${endDate}`;
  }
  return "/main/proxy/commission-list";
}

export function buildTransferAccountsUrl() {
  return "/main/finance/transfer-accounts";
}

export function normalizeTrendRows(trend) {
  if (!trend) {
    return [];
  }
  if (Array.isArray(trend)) {
    return trend.map((row) => ({ ...row }));
  }
  return Object.values(trend).map((row) => ({ ...row }));
}

export function formatPercent(value) {
  if (value == null) {
    return "—";
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return "—";
  }
  const prefix = num > 0 ? "+" : "";
  return `${prefix}${num}%`;
}
